import React, {useEffect, useState} from 'react';
// @ts-ignore
import { Badge, Col, ListGroupItem, Row } from 'reactstrap';
import "./ConversationRow.scss";
import {useSelector} from "react-redux";
import {RootState} from "../../../redux/store";

import moment from "moment-timezone";
// const webOn = require("../../Icons/custom_icons/WEBCHAT_ACTIVE.png")
// const voiceOn = require("../../Icons/custom_icons/PHONE_ACTIVE.png")
// const iosOn = require("../../Icons/custom_icons/IOS_APP_ACTIVE.png")
// const fbOn = require("../../Icons/custom_icons/FB_ACTIVE.png")
// const dashOn = require("../../Icons/custom_icons/DASHCHAT_ACTIVE.png")
// const smsOn = require("../../Icons/custom_icons/SMS_APP_ACTIVE.png")

type ConversationRowProps = {
  isActive: boolean,
  rowNum: number,
  formatCount: (num: any) => any,
  conversation: any,
  selectConversation: (conversation: any) => void
}
function ConversationRow({ isActive, rowNum, formatCount, conversation, selectConversation }: ConversationRowProps) {
  // @ts-ignore
  const timezone = useSelector((state: RootState) => state.settings.settings.timezone);
  const [rowColor, setRowColor] = useState<'white' | 'danger' | 'warning'>('white');
  const [badgeColor, setBadgeColor] = useState<'success' | 'warning'>('success');

  // function flagConversation(id: string, flagged: boolean) {
  //   apiCalls.flagConversation(id, flagged)
  //     .catch((err: any) => handleAPIError(err));
  // }

  useEffect(() => {
    if (conversation.totalErrors < 1) {
      setBadgeColor('success');
    } else {
      setBadgeColor('warning');
    }
  }, [conversation.totalErrors]);

  useEffect(() => {
    if (conversation.flagged && !isActive) {
      setRowColor('danger');
    } else if (conversation.errors > 0 && !isActive) {
      setRowColor('warning');
    } else {
      setRowColor('white')
    }
  }, [conversation.errors, conversation.flagged, isActive]);

  function handleSelectConversation() {
    selectConversation(conversation);
  }

  return (
    <ListGroupItem id={'conversation-row'} className={'conversation-row'} color={rowColor}
                   action active={isActive} onClick={handleSelectConversation}>
      <Row>
        <Col xs={2} className={'col-text-align-right'}>
          {formatCount(rowNum)}
        </Col>
        <Col xs={3} className={'col-text-align-right'}>
          {moment.tz(parseInt(conversation.startTime), timezone).format('MM/DD, h:mm A')}
        </Col>
        <Col xs={2} className={'col-text-align-right'}>
          {formatCount(conversation.steps)}
        </Col>
        <Col xs={3} className={'col-text-align-right'}>
          <Badge color={badgeColor}>
            {formatCount(conversation.totalErrors)}
          </Badge>
        </Col>
      </Row>
    </ListGroupItem>
  )
}

export default ConversationRow;
